/*
  AP-DEAL-SET — client logic for sections/ap-deal-set.liquid (forked from ap-crowned-set.js).
  State: which print (= which deal product), fabric, size. One deal product = hoodie dress + leggings in ONE SKU,
  so the cart add is ONE line, qty 1, no properties. The value stack (dress price, leggings value, shipping,
  you pay, save) is computed from the chosen variant's price + compare-at and the section's shipping value.
  Prints live in a bottom sheet (<dialog>) opened from the "Change print" row. The inline data carries every print
  in a compact form (first photo + variants); a print's other photos are fetched from /products/<handle>.js on touch/pick.
  Cart add = Shopify.actions.updateCart (the theme's cart drawer refreshes and opens), with the Kaching-safe
  /cart/add.js fetch from a blank iframe + the cart page as the fallback, same as ap-crowned-set.js.
  Upsells: the matching scarf (/products/<print>-bandana.js, shown only on 200 + in stock), "More sets" (the other
  prints, one set per add) and "Pair it with" (the same print's other garments from
  /search?view=ap-pair); both go through the quick-add sheet.
  Owner 13/10: the sheet + "More sets" carry only the best sellers (the Liquid sends <= 22 prints), chips show the
  whole hoodie dress (product.thumb), the size starts on the smallest one in stock, reviews are photo cards (tap = viewer),
  and "Compare" by the fabric buttons opens the fabric table.
*/
(function () {
  'use strict';

  var DISPLAY_SIZE = 'M'; // price shown before a size is picked (XS-3XL share a price; 4XL+ differ)

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  var cleanWin = null;
  function cleanFetch(path, opts) {
    try {
      if (!cleanWin || !cleanWin.fetch) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        f.src = 'about:blank';
        document.documentElement.appendChild(f);
        cleanWin = f.contentWindow;
      }
      return cleanWin.fetch(location.origin + path, opts);
    } catch (e) {
      return window.fetch(path, opts);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function init(root) {
    if (root.__apDs) return;
    root.__apDs = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-ap-ds-data]').textContent); } catch (e) { return; }
    var productsBase = data.productsBase || '/products/';
    // The inline payload is compact (157+ prints on every page): v = [id, size, fabric index, price, compare-at, available],
    // images = the first photo only unless "full" (the page's own product); the rest are fetched on demand (loadPhotos).
    var prints = [];
    (data.prints || []).forEach(function (p) {
      if (!p || !p.product) return;
      var pr = p.product;
      if (pr.v && !pr.variants) {
        pr.variants = pr.v.map(function (a) { return { id: a[0], s: a[1], f: (pr.fabrics || [])[a[2]] || null, p: a[3], c: a[4], a: !!a[5] }; });
        delete pr.v;
      }
      if (!pr.images) pr.images = pr.img ? [pr.img] : [];
      if (!pr.url) pr.url = productsBase + pr.handle;
      if (pr.variants && pr.variants.length) prints.push(p);
    });
    if (!prints.length) return;
    var $ = function (sel) { return root.querySelector(sel); };
    var money = function (c) { return formatMoney(c, data.moneyFormat); };
    var cdn = data.cdn || '';
    var viewQs = data.view ? '?view=' + data.view : '';

    prints.forEach(function (p) { if (p.name) p.product.name = p.name; });

    /* ---------- images: CDN product photos (resizable by ?width=) or theme-asset slides {src, srcset, thumb} ---------- */
    function full(u) { u = String(u); return /^https?:/.test(u) ? u : (/^\/\//.test(u) ? 'https:' + u : cdn + u); }
    function sized(url, w) {
      url = String(url);
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    // Photos beyond the first come from /products/<handle>.js the first time a print is touched or picked (cached on
    // the print). Resolves with true when the photo list changed. Prints with theme-asset slides never fetch.
    var skipImg = data.skipImages ? String(data.skipImages) : '';
    function base(u) { return String(u).split('?')[0].split('/').pop(); }
    function loadPhotos(p) {
      var pr = p.product;
      if ((p.slides && p.slides.length) || pr.full) return Promise.resolve(false);
      if (pr.__loading) return pr.__loading;
      pr.__loading = fetch(productsBase + pr.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }).then(function (j) {
        var list = (j.images || []).map(function (u) { return full(u); }).filter(function (u) { return !skipImg || u.indexOf(skipImg) < 0; }).slice(0, 10);
        pr.full = 1;
        if (list.length < 2) return false;
        var first = pr.images[0];
        pr.images = first && base(first) === base(list[0]) ? [first].concat(list.slice(1)) : list;
        return true;
      }).catch(function () { pr.__loading = null; return false; });
      return pr.__loading;
    }
    var SLIDE_SIZES = '(min-width: 990px) 560px, 100vw';
    function srcset(url) { return [600, 900, 1200, 1600].map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', '); }
    function slideSrc(s, w) { return typeof s === 'string' ? sized(full(s), w) : (w <= 240 ? s.thumb : s.src); }
    function slideSet(s) { return typeof s === 'string' ? srcset(full(s)) : s.srcset; }
    function slideBig(s) { return typeof s === 'string' ? sized(full(s), 1600) : s.src; }
    function photos(p) { return p.slides && p.slides.length ? p.slides : (p.product.images || []).filter(Boolean); }
    // Chip / print row / sticky photo: the whole hoodie dress (thumb) when the product has one, else the first photo
    function chipImg(p) {
      if (p.product.thumb) return sized(full(p.product.thumb), 300);
      var list = photos(p);
      return list.length ? slideSrc(list[0], 240) : '';
    }

    /* ---------- state ---------- */
    var start = 0;
    prints.forEach(function (p, i) { if (p.product.handle === data.defaultHandle) start = i; });
    function fabricsOf(prod) { return prod.fabrics && prod.fabrics.length ? prod.fabrics : [null]; }
    // sizeTouched: the shopper picked a size. Until then the size follows the smallest one in stock (owner 13/10);
    // after that, a print / fabric where the picked size is sold out clears it instead of quietly switching sizes.
    var state = { print: start, fabric: fabricsOf(prints[start].product)[0], size: null, sizeTouched: false };
    var cur = function () { return prints[state.print]; };
    var prod = function () { return cur().product; };

    function variantOf(prod, size, fabric) {
      var vs = prod.variants;
      for (var i = 0; i < vs.length; i++) if (vs[i].s === size && (!fabric || vs[i].f === fabric)) return vs[i];
      return null;
    }
    function variant(size) { return variantOf(prod(), size, state.fabric); }
    function smallestSize(pr, fabric) {
      var zs = pr.sizes || [];
      for (var i = 0; i < zs.length; i++) { var v = variantOf(pr, zs[i], fabric); if (v && v.a) return zs[i]; }
      return null;
    }
    // data.sizeSmallest = the section checkbox (off = nothing pre-picked, the button asks for a size)
    function fixSize() {
      if (state.size && (variant(state.size) || {}).a) return;
      state.size = state.sizeTouched || data.sizeSmallest === false ? null : smallestSize(prod(), state.fabric);
    }
    fixSize();
    function shownVariant() { return variant(state.size || DISPLAY_SIZE) || prod().variants[0]; }

    /* ---------- render: head (print name in the value stack + the URL) ---------- */
    function renderHead() {
      $('[data-ds-name]').textContent = prod().name;
      try { history.replaceState(null, '', prod().url + viewQs); } catch (e) { /* ignore */ }
    }

    /* ---------- slider: native scroll-snap track, rebuilt when the print changes ---------- */
    var slide = 0;
    var track = $('[data-ds-track]');
    function renderSlider() {
      var list = photos(cur()), key = prod().handle;
      if (!track || !list.length) return;
      // Rebuild on a new print, or when the print's photos arrived after the first (lazy) render
      if (track.getAttribute('data-print') !== key || track.children.length !== list.length) {
        track.setAttribute('data-print', key);
        track.innerHTML = list.map(function (s, i) {
          return '<img class="ap-ds__slide" data-ds-zoom src="' + esc(slideSrc(s, 900)) + '" srcset="' + esc(slideSet(s)) +
            '" sizes="' + SLIDE_SIZES + '" style="background-image:url(\'' + esc(slideSrc(s, i ? 200 : 240)) + '\')" alt="' +
            esc(prod().name + ' hoodie dress and leggings, photo ' + (i + 1) + ' of ' + list.length) + '" width="1200" height="1500" decoding="async">';
        }).join('');
        track.scrollLeft = 0;
        slide = 0;
      }
      syncSlider();
    }
    function syncSlider() {
      var n = track ? track.children.length : 0;
      $('[data-ds-slide-prev]').hidden = n < 2; $('[data-ds-slide-next]').hidden = n < 2;
      Array.prototype.forEach.call($('[data-ds-dots]').children, function (t, i) { t.setAttribute('aria-pressed', i === slide); });
    }
    function goTo(i) {
      var n = track ? track.children.length : 0;
      if (!n) return;
      slide = (i + n) % n;
      track.scrollTo({ left: slide * track.clientWidth, behavior: 'smooth' });
      syncSlider();
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== slide) { slide = i; syncSlider(); }
        });
      }, { passive: true });
    }
    var warmed = {};
    function warm(p) {
      loadPhotos(p).then(function () {
        photos(p).slice(0, 3).forEach(function (s) {
          var k = slideSrc(s, 900);
          if (warmed[k]) return;
          warmed[k] = 1;
          var im = new Image();
          im.sizes = SLIDE_SIZES;
          im.srcset = slideSet(s);
          im.src = k;
        });
      });
    }
    // After a print change: fetch its remaining photos, then refresh the slider / story / open viewer if it is still current
    function ensurePhotos() {
      var p = cur();
      loadPhotos(p).then(function (changed) {
        if (!changed || cur() !== p) return;
        renderThumbs();
        renderStory();
        if (lb && lb.open && !lbList) {
          $('[data-ds-lb-thumbs]').innerHTML = photos(p).map(function (s, i) {
            return '<button type="button" class="ap-ds__lbthumb" data-lb-idx="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(slideSrc(s, 160)) + '" alt="" width="64" height="64"></button>';
          }).join('');
          lbShow(view.idx);
        }
      });
    }
    function renderThumbs() {
      var list = photos(cur());
      $('[data-ds-dots]').innerHTML = list.length < 2 ? '' : list.map(function (s, i) {
        return '<button type="button" class="ap-ds__dot" data-slide="' + i + '" aria-label="Photo ' + (i + 1) + '"></button>';
      }).join('');
      renderSlider();
    }

    /* ---------- value stack: dress = variant price; save = compare-at - price; leggings = save - shipping ---------- */
    var SHIP = +data.shipCents || 0;
    function renderPrice() {
      var v = shownVariant(), save = Math.max(0, (v.c || 0) - v.p), leg = save - SHIP;
      $('[data-ds-price]').textContent = money(v.p);
      $('[data-ds-v-dress]').textContent = money(v.p);
      var legEl = $('[data-ds-v-leg]'), shipEl = $('[data-ds-v-ship]'), saveWrap = $('[data-ds-save-wrap]');
      legEl.hidden = !(leg > 0); legEl.textContent = leg > 0 ? money(leg) : '';
      shipEl.hidden = !(SHIP > 0 && save > 0); shipEl.textContent = money(SHIP);
      saveWrap.hidden = !(save > 0); $('[data-ds-v-save]').textContent = save > 0 ? money(save) : '';
    }

    /* ---------- photo viewer (<dialog>): the print's photos, or a list handed in (a review photo) ---------- */
    var lb = $('[data-ds-lb]'), lbImg = $('[data-ds-lb-img]'), lbStage = $('[data-ds-lb-stage]');
    var view = { idx: 0 }, lbList = null;
    function lbPhotos() { return lbList || photos(cur()); }
    function lbShow(idx) {
      var list = lbPhotos();
      if (!list.length) return;
      view.idx = (idx + list.length) % list.length;
      lbStage.classList.remove('is-zoomed');
      var want = view.idx, hi = new Image();
      lbImg.src = slideSrc(list[view.idx], 900);
      hi.onload = function () { if (view.idx === want && lb.open) lbImg.src = hi.src; };
      hi.src = slideBig(list[view.idx]);
      lbImg.alt = lbList ? $('[data-ds-lb-cap]').textContent : prod().name + ' hoodie dress and leggings, photo ' + (view.idx + 1);
      $('[data-ds-lb-count]').textContent = (view.idx + 1) + ' / ' + list.length;
      Array.prototype.forEach.call($('[data-ds-lb-thumbs]').children, function (b, i) { b.setAttribute('aria-pressed', i === view.idx); });
      var one = list.length < 2;
      $('[data-ds-lb-prev]').hidden = one; $('[data-ds-lb-next]').hidden = one;
    }
    function lbOpen(idx, list, cap) {
      if (!lb) return;
      lbList = list || null;
      $('[data-ds-lb-cap]').textContent = cap || (prod().name + ' · ' + money(shownVariant().p));
      $('[data-ds-lb-thumbs]').innerHTML = lbPhotos().length < 2 ? '' : lbPhotos().map(function (s, i) {
        return '<button type="button" class="ap-ds__lbthumb" data-lb-idx="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(slideSrc(s, 160)) + '" alt="" width="64" height="64"></button>';
      }).join('');
      lbShow(idx || 0);
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
      document.documentElement.classList.add('ap-ds-lock');
    }
    /* AP 03/11 - one owner for the scroll lock (same fix as ap-pick-set.js): the no-<dialog> fallback fires no
       'close' event, so html.ap-ds-lock used to stay on and the page froze on iOS < 15.4 / old in-app browsers. */
    function syncLock() {
      var ds = [lb, sheet, fc, qa], i, d, on = false;
      for (i = 0; i < ds.length; i++) { d = ds[i]; if (d && (d.open || d.hasAttribute('open'))) on = true; }
      document.documentElement.classList[on ? 'add' : 'remove']('ap-ds-lock');
    }
    window.addEventListener('pageshow', syncLock);
    function lbClose() {
      if (!lb) return;
      if (typeof lb.close === 'function' && lb.open) lb.close(); else { lb.removeAttribute('open'); syncLock(); }
    }
    if (lb) {
      lb.addEventListener('close', function () { lbList = null; syncLock(); });
      lb.addEventListener('click', function (e) {
        if (e.target === lb) { lbClose(); return; }
        var b = e.target.closest('button');
        if (b && b.hasAttribute('data-ds-lb-close')) lbClose();
        else if (b && b.hasAttribute('data-ds-lb-prev')) lbShow(view.idx - 1);
        else if (b && b.hasAttribute('data-ds-lb-next')) lbShow(view.idx + 1);
        else if (b && b.hasAttribute('data-lb-idx')) lbShow(+b.getAttribute('data-lb-idx'));
        else if (e.target === lbImg) {
          if (lbImg.__apPanned && Date.now() - lbImg.__apPanned < 250) return;
          var r = lbImg.getBoundingClientRect();
          lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          lbStage.classList.toggle('is-zoomed');
        }
      });
      lbImg.addEventListener('mousemove', function (e) {
        if (!lbStage.classList.contains('is-zoomed')) return;
        var r = lbStage.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') lbShow(view.idx - 1);
        else if (e.key === 'ArrowRight') lbShow(view.idx + 1);
      });
      // Touch inside the viewer is ours: swipe = next/prev; zoomed, a drag pans the 2x photo (no pull-to-refresh)
      var x0 = null, pan = null;
      function origin() {
        var o = (lbImg.style.transformOrigin || '50% 50%').split(' ').map(parseFloat);
        return [isNaN(o[0]) ? 50 : o[0], isNaN(o[1]) ? 50 : o[1]];
      }
      lbStage.addEventListener('touchstart', function (e) {
        var one = e.touches.length === 1;
        x0 = one ? e.touches[0].clientX : null;
        pan = one && lbStage.classList.contains('is-zoomed') ? { x: e.touches[0].clientX, y: e.touches[0].clientY, o: origin(), moved: false } : null;
      }, { passive: true });
      lbStage.addEventListener('touchmove', function (e) {
        e.preventDefault();
        if (!pan || e.touches.length !== 1) return;
        var r = lbStage.getBoundingClientRect();
        var dx = e.touches[0].clientX - pan.x, dy = e.touches[0].clientY - pan.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) pan.moved = true;
        var ox = Math.min(100, Math.max(0, pan.o[0] - dx / r.width * 100));
        var oy = Math.min(100, Math.max(0, pan.o[1] - dy / r.height * 100));
        lbImg.style.transformOrigin = ox + '% ' + oy + '%';
      }, { passive: false });
      lbStage.addEventListener('touchend', function (e) {
        if (pan) { if (pan.moved) lbImg.__apPanned = Date.now(); pan = null; return; }
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) lbShow(view.idx + (dx < 0 ? 1 : -1));
      });
    }

    /* ---------- print row + sheet (chips built once; only aria-pressed flips so the scroll position is kept) ---------- */
    // Sheet chips: the best sellers only. Entries with sheet:0 (same-theme sets for "More sets") come last in the
    // payload, so the chip at child position i is still prints[i].
    function chips(attr) {
      return prints.map(function (p, i) {
        if (p.sheet === 0) return '';
        return '<button type="button" class="ap-ds__chip" ' + attr + '="' + i + '">' +
          '<img src="' + esc(chipImg(p)) + '" alt="" width="104" height="104" loading="lazy"><b>' + esc(p.product.name) + '</b></button>';
      }).join('');
    }
    function pressOnly(strip, idx) {
      Array.prototype.forEach.call(strip.children, function (b, i) { b.setAttribute('aria-pressed', i === idx); });
    }
    function revealChip(strip, idx) {
      var active = strip.children[idx];
      if (!active) return;
      if (strip.classList.contains('ap-ds__strip--grid')) { active.scrollIntoView({ block: 'center' }); return; }
      strip.scrollLeft = Math.max(0, active.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft - 8);
    }
    function renderPrints() {
      var strip = $('[data-ds-prints]');
      if (!strip.children.length) strip.innerHTML = chips('data-print');
      pressOnly(strip, state.print);
      $('[data-ds-print-name]').textContent = prod().name;
      var ri = $('[data-ds-print-img]'), src = chipImg(cur());
      if (ri) { ri.hidden = !src; if (src && ri.getAttribute('src') !== src) ri.src = src; }
    }
    var sheet = $('[data-ds-sheet]');
    function sheetOpen() {
      if (!sheet) return;
      if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
      document.documentElement.classList.add('ap-ds-lock');
      revealChip($('[data-ds-prints]'), state.print);
    }
    function sheetClose() {
      if (!sheet) return;
      if (typeof sheet.close === 'function' && sheet.open) sheet.close(); else { sheet.removeAttribute('open'); syncLock(); }
    }
    if (sheet) {
      sheet.addEventListener('close', syncLock);
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheetClose(); });
    }

    // Fabric buttons: name + line + the price step up from the cheapest fabric (for the shown size), e.g. "+$45.00"
    function fabricButtons(prod, current, attr, small, size) {
      var fs = fabricsOf(prod).filter(Boolean);
      size = size || DISPLAY_SIZE;
      var base = Math.min.apply(null, fs.map(function (f) { var v = variantOf(prod, size, f); return v ? v.p : Infinity; }));
      return fs.map(function (f) {
        var v = variantOf(prod, size, f), up = v && isFinite(base) && v.p > base ? ' · +' + money(v.p - base) : '';
        return '<button type="button" class="ap-ds__opt" ' + attr + '="' + esc(f) + '" aria-pressed="' + (f === current) + '">' +
          '<b>' + esc(f) + '</b>' + (small ? '' : '<small>' + esc((data.fabricDesc || {})[f] || '') + esc(up) + '</small>') + '</button>';
      }).join('');
    }
    function sizeButtons(prod, fabric, current, attr) {
      return (prod.sizes || []).map(function (z) {
        var v = variantOf(prod, z, fabric), ok = !!(v && v.a);
        return '<button type="button" class="ap-ds__size" ' + attr + '="' + esc(z) + '" aria-pressed="' + (z === current) + '"' + (ok ? '' : ' disabled') + '>' + esc(z) + '</button>';
      }).join('');
    }
    function renderFabrics() {
      $('[data-ds-fabrics]').innerHTML = fabricButtons(prod(), state.fabric, 'data-fabric', false, state.size);
      $('[data-ds-fabric-name]').textContent = state.fabric || '';
    }
    function renderSizes() {
      $('[data-ds-sizes]').innerHTML = sizeButtons(prod(), state.fabric, state.size, 'data-size');
      $('[data-ds-size-name]').textContent = state.size || '';
    }
    function fill(t, name, price) { return String(t || '').replace('{name}', name).replace('{price}', price); }
    function renderCta() {
      var name = prod().name, price = money(shownVariant().p);
      $('[data-ds-atc]').textContent = fill(data.ctaTemplate, name, price);
      $('[data-ds-sticky-name]').textContent = fill(data.stickyTemplate, name, price);
      var si = $('[data-ds-sticky-img]'), src = chipImg(cur());
      if (si && src && si.getAttribute('src') !== src) si.src = src;
    }

    function renderStory() {
      var p = cur(), t = $('[data-ds-story-title]');
      if (!t) return;
      t.textContent = p.storyTitle || t.getAttribute('data-default') || '';
      var img = $('[data-ds-story-img]');
      var list = photos(p), src = p.storyImg || (list[1] || list[0] || null);
      if (img && src) {
        var key = typeof src === 'string' ? src : src.src;
        if (img.getAttribute('data-src') !== key) {
          img.setAttribute('data-src', key);
          img.sizes = '(min-width: 760px) 40vw, 100vw';
          img.srcset = typeof src === 'string' ? srcset(full(src)) : src.srcset;
          img.src = typeof src === 'string' ? sized(full(src), 900) : src.src;
        }
        img.alt = p.product.name + ' hoodie dress and leggings, worn';
      }
      var sp = $('[data-ds-story-print]');
      if (sp) sp.textContent = p.story || '';
      var wrap = $('[data-ds-story-quote-wrap]');
      if (wrap) {
        wrap.hidden = !p.storyQuote;
        $('[data-ds-story-quote]').textContent = p.storyQuote ? '“' + p.storyQuote + '”' : '';
        $('[data-ds-story-quote-who]').textContent = p.storyQuoteWho || '';
      }
    }

    /* ---------- extra dialogs (fabric compare, quick add): showModal + the page scroll lock ---------- */
    function openDlg(d) {
      if (!d) return;
      if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
      document.documentElement.classList.add('ap-ds-lock');
    }
    function closeDlg(d) {
      if (!d) return;
      if (typeof d.close === 'function' && d.open) d.close(); else { d.removeAttribute('open'); syncLock(); }
    }
    var fc = $('[data-ds-fc]'), qa = $('[data-ds-qa]');
    [fc, qa].forEach(function (d) {
      if (!d) return;
      d.addEventListener('close', syncLock);
      d.addEventListener('click', function (e) { if (e.target === d) closeDlg(d); });
    });

    /* ---------- "Pair it with": the same print's other garments (never hoodie dresses, leggings or deals) ---------- */
    var pairBox = $('[data-ds-pair]'), pairTrack = $('[data-ds-pair-track]');
    var pairCache = {}, pairReq = 0, pairList = [], pairOn = false;
    var PAIR_SKIP = /hoodie dress|leggings|\bdeal\b|\bbundle\b/;
    var pairOrder = String(data.pairOrder || '').toLowerCase().split(/\s*[,\n]\s*/).filter(Boolean);
    function norm(s) { return String(s || '').replace(/["“”]/g, '').replace(/\s+/g, ' ').trim().toLowerCase(); }
    function titleCase(s) { return s.replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
    function pairRank(kind) { for (var i = 0; i < pairOrder.length; i++) if (kind.indexOf(pairOrder[i]) > -1) return i; return pairOrder.length; }
    // Search results -> this print's other garments: title = "<Print> <garment>", one card per garment, ranked by pair_order
    function pairPick(list, p) {
      var name = norm(p.product.name), sh = scarfHandle(p), seen = {};
      return (list || []).map(function (x, i) {
        var t = norm(x.title);
        if (t.indexOf(name + ' ') !== 0) return null;
        var kind = t.slice(name.length + 1);
        if (!kind || PAIR_SKIP.test(kind) || /-(?:deal|bundle)(?:-\d+)?$/.test(x.handle) || x.handle === sh || /outfit set/i.test(x.type || '')) return null;
        return { x: x, kind: kind, r: pairRank(kind), i: i };
      }).filter(function (o) {
        if (!o || seen[o.kind]) return false;
        seen[o.kind] = 1;
        return true;
      }).sort(function (a, b) { return a.r - b.r || a.i - b.i; }).slice(0, +data.pairMax || 8).map(function (o) {
        o.x.kind = titleCase(o.kind);
        return o.x;
      });
    }
    function renderPair() {
      if (!pairBox || !pairOn) return;
      var p = cur(), key = p.product.handle, token = ++pairReq;
      function show(list) {
        if (token !== pairReq) return;
        pairList = list || [];
        pairBox.hidden = !pairList.length;
        pairTrack.innerHTML = pairList.map(function (x, i) {
          return '<div class="ap-ds__pcard" role="listitem">' +
            '<button type="button" class="ap-ds__pimg" data-pair="' + i + '" aria-label="' + esc(x.title) + '" aria-haspopup="dialog">' +
            (x.img ? '<img src="' + esc(sized(full(x.img), 400)) + '" alt="" width="400" height="500" loading="lazy">' : '') + '</button>' +
            '<b>' + esc(x.kind) + '</b><span>' + esc(money(x.price)) + '</span>' +
            '<button type="button" class="ap-ds__plus" data-pair="' + i + '" aria-label="' + esc((data.addLabel || 'Add') + ' ' + x.title) + '" aria-haspopup="dialog">' + esc(data.addLabel || '+ Add') + '</button></div>';
        }).join('');
        pairTrack.scrollLeft = 0;
      }
      if (key in pairCache) { show(pairCache[key]); return; }
      fetch('/search?q=' + encodeURIComponent(p.product.name) + '&type=product&view=ap-pair', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      }).then(function (t) {
        pairCache[key] = pairPick(JSON.parse(t), p);
        show(pairCache[key]);
      }).catch(function () { pairCache[key] = []; show([]); });
    }
    // The search runs once the area below the button comes near the screen, not on page load
    var more = root.querySelector('.ap-ds__more');
    if (pairBox && more) {
      if ('IntersectionObserver' in window) {
        var pio = new IntersectionObserver(function (es) {
          if (!es.some(function (e) { return e.isIntersecting; })) return;
          pio.disconnect(); pairOn = true; renderPair();
        }, { rootMargin: '400px' });
        pio.observe(more);
      } else { pairOn = true; }
    }

    /* ---------- quick add (a "Pair it with" product): option chips, the size starts on the set's size ---------- */
    var qaState = null, qaErr = $('[data-ds-qa-error]');
    function qaMatch(v, sel, skipK) { return v[1].every(function (o, k) { return k === skipK || o === sel[k]; }); }
    function qaVariant() {
      var s = qaState;
      if (!s) return null;
      for (var i = 0; i < s.x.v.length; i++) if (qaMatch(s.x.v[i], s.sel, -1)) return s.x.v[i];
      return null;
    }
    function qaValues(x, k) {
      var out = [];
      x.v.forEach(function (v) { if (out.indexOf(v[1][k]) < 0) out.push(v[1][k]); });
      return out;
    }
    function qaOpen(x) {
      if (!qa) return;
      var sel = [], firstAv = x.v.filter(function (v) { return v[3]; })[0] || x.v[0];
      (x.options || []).forEach(function (name, k) {
        var vals = qaValues(x, k), want = null;
        if (/size/i.test(name) && state.size && vals.indexOf(state.size) > -1) want = state.size;
        if (/fabric/i.test(name) && state.fabric && vals.indexOf(state.fabric) > -1) want = state.fabric;
        sel[k] = want || firstAv[1][k];
      });
      qaState = { x: x, sel: sel };
      if (!(qaVariant() || [])[3]) qaState.sel = firstAv[1].slice();
      $('[data-ds-qa-name]').textContent = x.title.replace(/"/g, '');
      var img = $('[data-ds-qa-img]');
      img.src = x.img ? sized(full(x.img), 500) : '';
      img.alt = x.title.replace(/"/g, '');
      img.hidden = !x.img;
      $('[data-ds-qa-link]').href = productsBase + x.handle;
      showError(qaErr, '');
      renderQa();
      openDlg(qa);
    }
    function renderQa() {
      var s = qaState, x = s.x;
      $('[data-ds-qa-opts]').innerHTML = (x.options || []).map(function (name, k) {
        var vals = qaValues(x, k);
        if (vals.length < 2) return '';
        return '<div class="ap-ds__k">' + esc(name) + '<span>' + esc(s.sel[k]) + '</span></div><div class="ap-ds__sizes ap-ds__qaopt" role="group" aria-label="' + esc(name) + '">' +
          vals.map(function (val) {
            var ok = x.v.some(function (v) { return v[3] && v[1][k] === val && qaMatch(v, s.sel, k); });
            return '<button type="button" class="ap-ds__size" data-qa-k="' + k + '" data-qa-val="' + esc(val) + '" aria-pressed="' + (val === s.sel[k]) + '"' + (ok ? '' : ' disabled') + '>' + esc(val) + '</button>';
          }).join('') + '</div>';
      }).join('');
      var v = qaVariant();
      $('[data-ds-qa-price]').textContent = money(v ? v[2] : x.price) + (x.isSet && data.setsNote ? ' · ' + data.setsNote : '');
    }

    /* ---------- upsell 1: "More sets" = the other prints in the list (owner 13/10, replaces "Add a 2nd set") ----------
       One card per print (whole-dress photo, name, price); "+ Add" opens the quick-add sheet with fabric + size and
       adds that ONE set (owner 13/10: never the set picked above as well). */
    var setsTrack = $('[data-ds-sets-track]');
    function setItem(i) {
      var p = prints[i], pr = p.product, fab = (pr.fabrics || []).length > 0;
      var v0 = variantOf(pr, DISPLAY_SIZE, fab ? (fabricsOf(pr).indexOf(state.fabric) > -1 ? state.fabric : pr.fabrics[0]) : null) || pr.variants[0];
      return {
        isSet: true, handle: pr.handle, title: pr.name + ' set', img: chipImg(p), price: v0.p,
        options: fab ? ['Fabric', 'Size'] : ['Size'],
        v: pr.variants.map(function (v) { return [v.id, fab ? [v.f, v.s] : [v.s], v.p, v.a ? 1 : 0]; })
      };
    }
    // Order (owner 13/10): the current print's theme tag first (faith, afrocentric…; untagged with untagged), then
    // the rest; each group in payload order = best-selling order. Up to data.setsMax cards.
    function setsOrder() {
      var tag = cur().tag || '';
      return prints.map(function (p, i) { return i; }).filter(function (i) { return i !== state.print; }).sort(function (a, b) {
        return ((prints[a].tag || '') !== tag) - ((prints[b].tag || '') !== tag) || a - b;
      }).slice(0, +data.setsMax || 12);
    }
    function renderSets() {
      if (!setsTrack) return;
      setsTrack.innerHTML = setsOrder().map(function (i) {
        var p = prints[i], x = setItem(i);
        return '<div class="ap-ds__pcard ap-ds__pcard--set" role="listitem">' +
          '<button type="button" class="ap-ds__pimg" data-set="' + i + '" aria-label="' + esc(x.title) + '" aria-haspopup="dialog">' +
          (x.img ? '<img src="' + esc(x.img) + '" alt="" width="300" height="400" loading="lazy">' : '') + '</button>' +
          '<b>' + esc(p.product.name) + '</b><span>' + esc(money(x.price)) + '</span>' +
          '<button type="button" class="ap-ds__plus" data-set="' + i + '" aria-label="' + esc((data.addLabel || 'Add') + ' ' + x.title) + '" aria-haspopup="dialog">' + esc(data.addLabel || '+ Add') + '</button></div>';
      }).join('');
      setsTrack.scrollLeft = 0;
    }

    /* ---------- upsell 2: the matching scarf, only when /products/<print>-bandana.js answers 200 + in stock ---------- */
    var scarfBox = $('[data-ds-scarf]'), scarfCache = {}, scarfReq = 0, scarf = null;
    function scarfHandle(p) {
      if (p.scarfHandle) return p.scarfHandle;
      return p.product.handle.replace(/-(?:hoodie-dress|dress-hoodie|hoodie|dress)?-?leggings(?:-deal|-bundle)?$/, '') + (data.scarfSuffix || '-bandana');
    }
    function renderScarf() {
      if (!scarfBox) return;
      var h = scarfHandle(cur()), token = ++scarfReq;
      scarf = null;
      scarfBox.hidden = true;
      var show = function (s) {
        if (token !== scarfReq || !s) return;
        scarf = s;
        $('[data-ds-scarf-img]').src = s.img ? sized(s.img, 240) : '';
        $('[data-ds-scarf-name]').textContent = s.title;
        $('[data-ds-scarf-price]').textContent = money(s.price);
        $('[data-ds-scarf-btn]').setAttribute('aria-label', fill(data.scarfTemplate, s.title, money(s.price)));
        scarfBox.hidden = false;
      };
      if (h in scarfCache) { show(scarfCache[h]); return; }
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }).then(function (j) {
        var v = (j.variants || []).filter(function (x) { return x.available; })[0];
        var img = j.featured_image || (j.images && j.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img && img.indexOf('width=') < 0) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        scarfCache[h] = j.available && v ? { id: v.id, title: j.title, price: v.price, img: img } : null;
        show(scarfCache[h]);
      }).catch(function () { scarfCache[h] = null; show(null); });
    }

    function render() { renderHead(); renderThumbs(); renderPrice(); renderPrints(); renderFabrics(); renderSizes(); renderCta(); renderStory(); renderSets(); renderScarf(); renderPair(); ensurePhotos(); }

    /* ---------- events ---------- */
    var err = $('[data-ds-error]'), scarfErr = $('[data-ds-scarf-error]');
    var sizeStep = $('[data-ds-size-step]');
    function showError(el, msg) { if (!el) return; el.textContent = msg || ''; el.hidden = !msg; }

    // Size guide: the triggers carry data-ap-sg-open; snippets/ap-size-guide-hoodie-leggings.liquid opens the popup itself.

    root.addEventListener('click', function (e) {
      var z = e.target.closest('[data-ds-zoom]');
      if (z && root.contains(z) && !(lb && lb.contains(z))) { lbOpen(slide); return; }
      var rp = e.target.closest('[data-ds-rv-photo]');
      if (rp && root.contains(rp)) {
        var who = rp.getAttribute('data-who') || '';
        lbOpen(0, [{ src: rp.getAttribute('data-big'), thumb: rp.getAttribute('data-src'), srcset: '' }], String(data.rvCaption || '{name}').replace('{name}', who));
        return;
      }
      var t = e.target.closest('button');
      if (!t || !root.contains(t) || (lb && lb.contains(t))) return;
      if (t.hasAttribute('data-ds-fc-open')) {
        openDlg(fc);
      } else if (t.hasAttribute('data-ds-fc-close')) {
        closeDlg(fc);
      } else if (t.hasAttribute('data-pair')) {
        var px = pairList[+t.getAttribute('data-pair')];
        if (px) qaOpen(px);
      } else if (t.hasAttribute('data-ds-qa-close')) {
        closeDlg(qa);
      } else if (t.hasAttribute('data-qa-k')) {
        // Pick a value; when that leaves no variant in stock, move the other options to the first in-stock one with it
        var k = +t.getAttribute('data-qa-k'), val = t.getAttribute('data-qa-val');
        qaState.sel[k] = val;
        if (!(qaVariant() || [])[3]) {
          var alt = qaState.x.v.filter(function (v) { return v[3] && v[1][k] === val; })[0];
          if (alt) qaState.sel = alt[1].slice();
        }
        showError(qaErr, ''); renderQa();
      } else if (t.hasAttribute('data-slide')) {
        goTo(+t.getAttribute('data-slide'));
      } else if (t.hasAttribute('data-ds-slide-prev') || t.hasAttribute('data-ds-slide-next')) {
        goTo(slide + (t.hasAttribute('data-ds-slide-next') ? 1 : -1));
      } else if (t.hasAttribute('data-ds-print-open')) {
        sheetOpen();
      } else if (t.hasAttribute('data-ds-sheet-close')) {
        sheetClose();
      } else if (t.hasAttribute('data-print')) {
        state.print = +t.getAttribute('data-print');
        slide = 0;
        if (fabricsOf(prod()).indexOf(state.fabric) < 0) state.fabric = fabricsOf(prod())[0];
        fixSize();
        sheetClose();
        render();
      } else if (t.hasAttribute('data-fabric')) {
        state.fabric = t.getAttribute('data-fabric');
        fixSize();
        renderFabrics(); renderSizes(); renderPrice(); renderCta(); renderSets();
      } else if (t.hasAttribute('data-size')) {
        state.size = t.getAttribute('data-size');
        state.sizeTouched = true;
        sizeStep.classList.remove('is-missing'); showError(err, '');
        renderFabrics(); renderSizes(); renderPrice(); renderCta();
      } else if (t.hasAttribute('data-set')) {
        qaOpen(setItem(+t.getAttribute('data-set')));
      } else if (t.hasAttribute('data-ds-sticky-btn')) {
        $('[data-ds-atc]').click();
      }
    });

    /* ---------- add to cart (one call = one or more lines, qty 1 each) ---------- */
    function addLines(ids, btn, busy, errEl, done) {
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = busy;
      showError(errEl, '');
      function reset() { btn.disabled = false; btn.textContent = label; }
      function fail(msg) { reset(); showError(errEl, msg || 'Something stopped your set reaching the cart. Tap once more.'); }
      // The same variant twice (2nd set = same print, fabric and size as set 1) becomes one line with qty 2
      var items = [];
      ids.forEach(function (id) {
        var it = items.filter(function (x) { return x.id === id; })[0];
        if (it) it.quantity++; else items.push({ id: id, quantity: 1 });
      });

      // Fallback: the clean /cart/add.js call (Kaching-safe) and the cart page.
      function viaCartPage() {
        cleanFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items }),
        }).then(function (r) {
          return r.text().then(function (txt) {
            var j = null;
            try { j = JSON.parse(txt); } catch (e2) { /* bot-check HTML */ }
            if (r.ok && j) return j;
            throw { status: r.status, json: j };
          });
        }).then(function () {
          window.location.href = data.cartUrl || '/cart';
        }).catch(function (e3) { fail(e3 && e3.json && e3.json.description); });
      }

      // Preferred: Shopify's standard cart action (the path the theme's own product form uses): the cart drawer
      // refreshes and opens. If it errors, check whether the line landed before falling back, so nothing is added twice.
      var act = window.Shopify && window.Shopify.actions;
      if (!act || typeof act.updateCart !== 'function' || !document.querySelector('theme-drawer#cart-drawer')) {
        viaCartPage();
        return;
      }
      Promise.resolve().then(function () {
        return act.updateCart({ lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: it.quantity }; }) });
      }).then(function (res) {
        var errs = (res && (res.userErrors || (res.cart && res.cart.userErrors))) || [];
        if (errs.length) { fail(errs[0].message); return; }
        reset();
        if (done) done();
      }).catch(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var landed = (cart.items || []).some(function (i) { return ids.indexOf(i.variant_id) > -1 || ids.indexOf(i.id) > -1; });
          if (landed) { reset(); if (done) done(); if (typeof act.openCart === 'function') act.openCart(); } else viaCartPage();
        }).catch(viaCartPage);
      });
    }

    var atc = $('[data-ds-atc]');
    atc.addEventListener('click', function () {
      if (!state.size) {
        sizeStep.classList.add('is-missing');
        sizeStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showError(err, 'Pick your size first.');
        return;
      }
      var v = variant(state.size);
      if (!v || !v.a) { showError(err, 'That size is sold out in this fabric.'); return; }
      addLines([v.id], atc, 'Adding your set…', err);
    });
    // Quick add ("More sets" or "Pair it with"): one line, that item only. The sheet closes once it is in, so the
    // theme's cart drawer is not hidden behind the modal.
    var qaBtn = $('[data-ds-qa-btn]');
    if (qaBtn) qaBtn.addEventListener('click', function () {
      var v = qaVariant();
      if (!v || !v[3]) { showError(qaErr, 'That option is sold out. Pick another one.'); return; }
      addLines([v[0]], qaBtn, 'Adding…', qaErr, function () { closeDlg(qa); });
    });
    var scarfBtn = $('[data-ds-scarf-btn]');
    if (scarfBtn) scarfBtn.addEventListener('click', function () {
      if (!scarf) return;
      addLines([scarf.id], scarfBtn, 'Adding…', scarfErr);
    });

    /* ---------- mobile sticky: shown whenever the main button is off screen ---------- */
    var sticky = $('[data-ds-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-shown', !entries[0].isIntersecting);
      }).observe(atc);
    }

    // Touch / hover on a print chip = intent: start loading that print's photos before the tap lands
    var strip = $('[data-ds-prints]');
    ['touchstart', 'mouseover', 'focusin'].forEach(function (ev) {
      strip.addEventListener(ev, function (e) {
        var c = e.target.closest && e.target.closest('[data-print]');
        if (c) warm(prints[+c.getAttribute('data-print')]);
      }, { passive: true });
    });

    render();
    function afterLoad() { (window.requestIdleCallback || function (f) { setTimeout(f, 800); })(function () { warm(cur()); }); }
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
  }

  function boot() { document.querySelectorAll('[data-ap-ds]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
